var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGermanyFlag24 = function SvgGermanyFlag24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#germany-flag-24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC1C24",
    d: "M0 8.984h23v5.032H0V8.984Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25333A",
    d: "M19.406 3.594H3.594C1.212 3.594 0 5.364 0 7.547v1.437h23V7.547c0-2.183-1.212-3.953-3.594-3.953Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CB38",
    d: "M0 15.453c0 2.183 1.212 3.953 3.594 3.953h15.812c2.382 0 3.594-1.77 3.594-3.953v-1.437H0v1.437Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "germany-flag-24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z"
  })))));
};
export default SvgGermanyFlag24;